import {DatePicker, Input, InputNumber, Switch} from "antd";
import dayjs from "dayjs";
import {
    CONFIG_DATE_FIELDS,
    CONFIG_FLAG_FIELDS,
    CONFIG_NUMBER_FIELDS,
    CONFIG_STORE_AND_HARDWARE_FIELDS,
    UPDATE_DEVICE_CONFIG_CONTAINERS,
} from "./configFields";

const {TextArea} = Input;

const formatDate = (value) => value ? dayjs(value).format("YYYY-MM-DD") : null;

const AdditionalFieldsComponent = ({
    data,
    onChange,
    disabled = false,
    canEditField = () => true,
}) => {
    const isDisabled = (field, container) =>
        disabled || !canEditField(field, container);

    return (
        <div className="config-fields">
            <div className="config-fields__group">
                <h3>Store and hardware</h3>
                <div className="create-device__field-grid create-device__field-grid--compact">
                    {CONFIG_STORE_AND_HARDWARE_FIELDS.map((field) => {
                        const InputComponent = field.secure ? Input.Password : Input;

                        if (field.wide) {
                            return (
                                <label className="create-device__field create-device__field--wide" key={field.name}>
                                    <span className="create-device__field-label">{field.label}</span>
                                    <TextArea
                                        className="create-device__control"
                                        placeholder={field.label}
                                        allowClear
                                        disabled={isDisabled(field.name, UPDATE_DEVICE_CONFIG_CONTAINERS.storeAndHardware)}
                                        autoSize={{minRows: 3, maxRows: 6}}
                                        value={data[field.name] || ""}
                                        onChange={(event) => onChange({[field.name]: event.target.value})}
                                    />
                                </label>
                            );
                        }

                        return (
                            <label className="create-device__field" key={field.name}>
                                <span className="create-device__field-label">{field.label}</span>
                                <InputComponent
                                    className="create-device__control"
                                    placeholder={field.label}
                                    allowClear
                                    autoComplete="off"
                                    disabled={isDisabled(field.name, UPDATE_DEVICE_CONFIG_CONTAINERS.storeAndHardware)}
                                    value={data[field.name] || ""}
                                    onChange={(event) => onChange({[field.name]: event.target.value})}
                                />
                            </label>
                        );
                    })}
                </div>
            </div>

            <div className="config-fields__group">
                <h3>Numbers and dates</h3>
                <div className="create-device__field-grid create-device__field-grid--compact">
                    {CONFIG_NUMBER_FIELDS.map((field) => (
                        <label className="create-device__field" key={field.name}>
                            <span className="create-device__field-label">{field.label}</span>
                            <InputNumber
                                className="create-device__control"
                                placeholder={field.label}
                                precision={field.precision}
                                min={field.min}
                                max={field.max}
                                disabled={isDisabled(field.name, UPDATE_DEVICE_CONFIG_CONTAINERS.numbersAndDates)}
                                value={data[field.name] ?? null}
                                parser={(value) => value?.replace(",", ".")}
                                onChange={(value) => onChange({[field.name]: value})}
                            />
                        </label>
                    ))}

                    {CONFIG_DATE_FIELDS.map((field) => (
                        <label className="create-device__field" key={field.name}>
                            <span className="create-device__field-label">{field.label}</span>
                            <DatePicker
                                className="create-device__control"
                                format="YYYY-MM-DD"
                                allowClear
                                disabled={isDisabled(field.name, UPDATE_DEVICE_CONFIG_CONTAINERS.numbersAndDates)}
                                value={data[field.name] ? dayjs(data[field.name]) : null}
                                onChange={(value) => onChange({[field.name]: formatDate(value)})}
                            />
                        </label>
                    ))}
                </div>
            </div>

            <div className="config-fields__group">
                <h3>Flags</h3>
                <div className="config-fields__switch-grid">
                    {CONFIG_FLAG_FIELDS.map((field) => (
                        <label className="config-fields__switch" key={field.name}>
                            <span>{field.label}</span>
                            <Switch
                                checked={Boolean(data[field.name])}
                                disabled={isDisabled(field.name, UPDATE_DEVICE_CONFIG_CONTAINERS.flags)}
                                onChange={(checked) => onChange({[field.name]: checked})}
                            />
                        </label>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default AdditionalFieldsComponent;
